var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"simulation-list"},[_vm._l((_vm.filteredSimulationList),function(item){return _c('div',{key:item.id},[_c('SimulationItem',{attrs:{"item":item}})],1)}),_vm._l((10),function(_){return _c('div',{staticClass:"emptyItem"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }